<div [formGroup]="form">
  @if (isVariacao) {
    <div class="section-container" id="variacoes">
      <div class="section-title d-flex justify-content-between align-items-center">
        <div class="d-flex align-items-center">
          <mat-icon class="me-2">style</mat-icon>
          <span>Variações</span>
        </div>
      </div>

      <!-- Grid: Tipos de Variação -->
      <div formArrayName="variacoes">
        <div class="grid-header">
          <p class="mb-0">Tipos de Variação</p>
          <button mat-button type="button" (click)="addVariacaoRow()">
            <mat-icon>add</mat-icon> Adicionar Variação
          </button>
        </div>

        @for (item of variacoes.controls; track item; let i = $index) {
          <div [formGroupName]="i" class="form-row-separator">
            <div class="row">
              <div class="col-10 col-md-11">
                <div class="row g-2">
                  <!-- Tipo de Variação -->
                  <div class="col-12 col-lg-4">
                    <app-select-pesquisavel
                      [offlineList]="getListaVariacoesDisponiveis(i)"
                      [control]="getControl(item, 'idVariacao')"
                      idField="id"
                      nameField="descricao"
                      label="Tipo de Variação"
                      placeholder="Selecione...">
                    </app-select-pesquisavel>
                  </div>
                  <!-- Valores -->
                  <div class="col-12 col-lg-8">
                    @if (variationValuesMap.get(i)) {
                      <mat-form-field appearance="outline" class="w-100">
                        <mat-label>Valores</mat-label>
                        <mat-chip-grid #chipGrid>
                          @for (
                            valor of getControl(item, 'listVariacaoValor').value;
                            track valor;
                            let idx = $index
                          ) {
                            <mat-chip-row (removed)="removeVariacaoValor(i, idx)">
                              {{ valor.descricao || valor.valor || valor }}
                              <button matChipRemove><mat-icon>cancel</mat-icon></button>
                            </mat-chip-row>
                          }
                        </mat-chip-grid>
                        <input
                          matInput
                          placeholder="Digite ou selecione..."
                          [matChipInputFor]="chipGrid"
                          [matAutocomplete]="auto"
                          #variacaoInput
                          (input)="filterVariationValues(i, variacaoInput.value)"
                          (matChipInputTokenEnd)="addCustomVariationValue(i, $event)" />
                        <mat-autocomplete
                          #auto="matAutocomplete"
                          (optionSelected)="adicionarVariacaoValor(i, $event, variacaoInput)">
                          @for (option of variationValuesMap.get(i); track option.id) {
                            <mat-option [value]="option">{{ option.descricao }}</mat-option>
                          }
                        </mat-autocomplete>
                      </mat-form-field>
                    }
                  </div>
                </div>
              </div>
              <!-- Delete -->
              <div class="col-2 col-md-1 produto-grid-delete-col">
                <button
                  mat-icon-button
                  class="delete-button produto-grid-delete-button"
                  type="button"
                  (click)="removeVariacaoRow(i)"
                  matTooltip="Remover">
                  <mat-icon class="material-symbols-outlined">delete</mat-icon>
                </button>
              </div>
            </div>
          </div>
        }

        @if (variacoes.length === 0) {
          <app-empty-state icon="style" title="Nenhuma variação adicionada."
            subtitle="Adicione um tipo de variação (ex.: Tamanho, Cor) e seus valores para gerar as combinações do produto.">
          </app-empty-state>
        }
      </div>

      <div class="d-flex justify-content-end mb-4 mt-2">
        <button mat-button type="button" (click)="gerarGrade()" [disabled]="isLoading">
          <mat-icon class="me-1">grid_on</mat-icon> Gerar Variações
        </button>
      </div>

      <!-- Grade de Variações Gerada (combinacoes) -->
      @if (combinacoes.length > 0) {
        <div>
          <hr />
          <h6 class="mb-3 fw-bold">Grade de Variações Gerada</h6>
          <div formArrayName="combinacoes">
            @for (item of combinacoes.controls; track item; let i = $index) {
              <div [formGroupName]="i" class="form-row-separator">
                <div class="row">
                  <div class="col-10 col-md-11">
                    <div class="row">
                      <!-- Variação -->
                      <div class="col-12 col-lg-3">
                        <span class="variacao-nome">{{ item.get('nomeVariavel')?.value }}</span>
                      </div>
                      <!-- SKU -->
                      <div class="col-6 col-lg-3">
                        <mat-form-field appearance="outline">
                          <mat-label>SKU</mat-label>
                          <input
                            matInput
                            formControlName="codigoSku"
                            [placeholder]="isSkuDisabled() ? 'Automático' : 'Digite o SKU'"
                            [matTooltip]="isSkuDisabled()
                              ? 'Código automático. Este campo está desativado porque o sistema gera o SKU automaticamente. Se quiser digitar manualmente, altere as configurações de cadastro de produto.'
                              : ''" />
                        </mat-form-field>
                      </div>
                      <!-- EAN / GTIN -->
                      <div class="col-6 col-lg-2">
                        <mat-form-field appearance="outline">
                          <mat-label>EAN / GTIN</mat-label>
                          <input matInput formControlName="gtinEan" />
                        </mat-form-field>
                      </div>
                      <!-- Preço Venda -->
                      <div class="col-6 col-lg-3">
                        <mat-form-field appearance="outline">
                          <mat-label>Preço Venda</mat-label>
                          <input
                            matInput
                            formControlName="preco"
                            currencyMask
                            [options]="{ prefix: 'R$ ' }" />
                        </mat-form-field>
                      </div>
                      <!-- Estoque -->
                      <div class="col-6 col-lg-1">
                        <button
                          mat-stroked-button
                          type="button"
                          class="btn-mini-estoque btn-secondary"
                          [class.btn-estoque-pendente]="variacaoIncompleta(item)"
                          (click)="abrirModalEstoque(i)"
                          [matTooltip]="variacaoIncompleta(item) ? 'Estoque incompleto: informe lote/série' : 'Gerenciar Estoque'"
                          [matBadge]="item.get('estoque')?.value?.length"
                          [matBadgeHidden]="!item.get('estoque')?.value?.length"
                          matBadgeColor="accent">
                          <mat-icon>{{ variacaoIncompleta(item) ? 'error' : 'assignment_turned_in' }}</mat-icon>
                        </button>
                        @if (variacaoIncompleta(item)) {
                          <span class="selo-incompleto">Estoque incompleto</span>
                        }
                      </div>
                    </div>
                  </div>
                  <!-- Delete -->
                  <div class="col-2 col-md-1 produto-grid-delete-col">
                    <button
                      mat-icon-button
                      class="delete-button produto-grid-delete-button"
                      type="button"
                      (click)="removeCombinacaoRow(i)"
                      matTooltip="Remover">
                      <mat-icon class="material-symbols-outlined">delete</mat-icon>
                    </button>
                  </div>
                </div>
              </div>
            }
          </div>
        </div>
      }
    </div>
  }
</div>
